module.exports = __webpack_public_path__ + "static/img/cl_beiantb_n.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/cl_beiantb_n.png
// module id = k3Z8
// module chunks = 30